import React from 'react'
import { BsLinkedin } from 'react-icons/bs'
import { FaGithub, FaCode } from 'react-icons/fa'
import './footer.css'

const Footer = () => {
	const currentYear = new Date().getFullYear();
  return (
    <footer>
    	<p href="#" className='footer__logo'>Thank you for visiting!</p>

		<div className="footer__socials">
			<a href="https://www.linkedin.com/in/tejas-patne/"><BsLinkedin /></a>
			<a href="https://github.com/TejasPatne"><FaGithub /></a>
			<a href="https://leetcode.com/u/TejasPatne/"><FaCode /></a>
		</div>

		<div className="footer__copyright">
			<small>Tejas Patne &copy; {currentYear}.</small>
		</div>
    </footer>
  )
}

export default Footer